export async function verifyDeletePassword(password) {
  const res = await fetch("/api/auth/delete", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ password }),
  });

  if (res.status === 503) return "not-configured";
  if (res.ok) return "ok";
  return "fail";
}

export async function submitDeleteAuth(password, onAuthenticated) {
  try {
    const result = await verifyDeletePassword(password);
    onAuthenticated(result);
    return result;
  } catch {
    onAuthenticated("fail");
    return "fail";
  }
}
